var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformanceUpGraphSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 317.484,
    fill: "#ecb885",
    width: 80,
    height: 146.516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 237.484,
    fill: "#ecb885",
    width: 80,
    height: 226.516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 141.484,
    fill: "#ecb885",
    width: 80,
    height: 322.516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 45.484,
    fill: "#ecb885",
    width: 80,
    height: 418.516
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecb885",
    points: "16,496 16,0 0,0 0,496 0,512 16,512 512,512 512,496  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceUpGraphSvgrepoCom);
export default __webpack_public_path__ + "static/media/performance-up-graph-svgrepo-com.05f6d8a1bb0a4879209b4b0f74f3f6c9.svg";
export { ForwardRef as ReactComponent };